import { RequestStatus } from '@features/request/requestSlice';
import { pushIfValue } from '@utils';
import { useRequest } from 'features/request/useRequest';
import { useDebounce } from 'uikit';

import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { catalogIsUniqueNameOtherCostTemplateGql } from '../../catalogUerOtherCostTemplatesQueries';

export const useIsUniqueNameOtherCostTemplate = ({
    name,
}: {
    name: string;
}): { isUniqueNameFetching: boolean; isUniqueName: boolean } => {
    const dispatch = useDispatch();

    const variables = useMemo(() => {
        const nameF = name?.length ? { name: { eq: name } } : undefined;
        const and: any[] = [];

        pushIfValue(and, nameF);

        const where = and?.length
            ? {
                  and,
              }
            : undefined;

        return { where };
    }, [name]);

    const [uniqueData, uniqueDataStatus, , isUniqueRequest] = useRequest({
        requestId: 'IsUniqueNameOtherCostTemplate',
        query: catalogIsUniqueNameOtherCostTemplateGql,
        variables,
        withEffect: false,
    });

    const debounceCheck = useDebounce(() => {
        if (name) {
            dispatch(isUniqueRequest(variables));
        }
    }, 500);

    useEffect(() => debounceCheck(), [debounceCheck, name]);

    return {
        isUniqueName: uniqueData?.catalogUEROtherCostTemplates?.totalCount === 0,
        isUniqueNameFetching: uniqueDataStatus === RequestStatus.FETCHING,
    };
};
